export enum KycFlagName {
  ProductCreated = 'product_created',
  WebActive = 'web_active',
  IdentityValidation = 'identity_validation',
}
